<template>
    <div>
        <div class="app-title">
            <div>
                <h2>{{ $t("tlt.systemParameters.list") }}</h2>
                <ul class="app-breadcrumb breadcrumb">
                    <li class="breadcrumb-item"><router-link to="/"><i class="fa fa-home"></i></router-link></li>
                    <li class="breadcrumb-item"><router-link to="/adm"><span>{{$t('tlt.administration')}}</span></router-link></li>
                    <li class="breadcrumb-item"><router-link to="/adm/systemParameters"><span>{{$t('tlt.systemParameters')}}</span></router-link></li>
                </ul>
            </div>
            <div class="col-lg-4">
                <div class="float-lg-right">
                    <mmf-button type="add"
                                show-name
                                v-bind:class="'btn btn-outline-primary'"
                                v-on:click="MMFNew('systemParameters')">
                    </mmf-button>
                    <!-- <button class="btn btn-outline-primary" v-on:click="MMFNew('systemParameters')">
                        <i class="fa fa-fw fa-lg fa-plus"></i>
                        <span class="text">{{ $t("btn.basic.add") }}</span>
                    </button> -->
                </div>
            </div>
        </div>
        <section class="app-content">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div
                        id="collapseOne"
                        class="collapse show "
                        aria-labelledby="headingOne"
                        data-parent="#accordionFilter"
                        >
                        <div class="card-body">
                            <form class="row">
                                <div class="form-group col-md-2">
                                    <label class="control-label">
                                        {{ $t("lbl.basic.group") }}:
                                    </label>
                                    <select class="form-control" v-model="groupFilter">
                                        <option value="">{{ $t("lbl.basic.select.one") }}</option>
                                        <option value="S">{{ $t("lbl.systemParameters.system") }}</option>
                                        <option value="E">{{ $t("lbl.systemParameters.endPoint") }}</option>
                                        <option value="F">{{ $t("lbl.systemParameters.functional") }}</option>
                                        <option value="Y">{{ $t("lbl.systemParameters.synchronous") }}</option>
                                        <option value="A">{{ $t("lbl.systemParameters.asynchronous") }}</option>
                                    </select>
                                </div>
                                <div class="form-group col-md-2">
                                    <label class="control-label">
                                        {{ $t("lbl.systemParameters.dataType") }} :
                                    </label>
                                    <select class="form-control" v-model="dataTypeFilter">
                                        <option value="">{{ $t("lbl.basic.select.one") }}</option>
                                        <option value="T">{{ $t("lbl.systemParameters.text") }}</option>
                                        <option value="D">{{ $t("lbl.basic.date") }}</option>
                                        <option value="N">{{ $t("lbl.systemParameters.number") }}</option>
                                        <option value="J">{{ $t("lbl.systemParameters.json") }}</option>
                                        <option value="X">{{ $t("lbl.systemParameters.xml") }}</option>
                                        <option value="U">{{ $t("lbl.systemParameters.url") }}</option>
                                        <option value="B">{{ $t("lbl.systemParameters.boolean") }}</option>
                                        <option value="P">{{ $t("lbl.systemParameters.properties") }}</option>
                                        <option value="Y">{{ $t("lbl.systemParameters.yml") }}</option>
                                    </select>
                                </div>
                                <div class="form-group col-md-2">
                                    <label class="control-label">
                                        {{ $t("lbl.basic.code") }} :
                                    </label>
                                    <input class="form-control" type="text" v-model="codeFilter"/>
                                </div>
                                <div class="form-group col-md-2">
                                    <label class="control-label">
                                        {{ $t("lbl.basic.value") }}:
                                    </label>
                                    <input class="form-control" type="text" v-model="valueFilter"/>
                                </div>
                                <div class="form-group col-md-2">
                                    <label class="control-label">
                                        {{ $t("lbl.basic.active") }} :
                                    </label>
                                    <select class="form-control" v-model="activeFilter">
                                        <option value="">{{ $t("lbl.basic.select.one") }}</option>
                                        <option value="true">{{ $t("lbl.basic.yes") }}</option>
                                        <option value="false">{{ $t("lbl.basic.no") }}</option>
                                    </select>
                                </div>
                                <div class="col-lg-2 align-self-end">
                                    <div class="float-lg-right">
                                        <button class="btn btn-outline-secondary mr-1" type="button" 
                                         v-on:click="MMFClearFilter('systemParameters')">
                                            <i class="fa fa-fw fa-lg fa-eraser"></i>
                                            <span class="text">{{ $t("btn.basic.clear") }}</span>
                                        </button>
                                        <button class="btn btn-primary" type="button" v-on:click="MMFLoadRows('systemParameters')">
                                            <i class="fa fa-fw fa-lg fa-search"></i>
                                            <span class="text">{{ $t("btn.basic.search") }}</span>
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <div id="systemParametersResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo"
                         class="collapse show"
                         aria-labelledby="headingTwo"
                         data-parent="#accordionResult">

                        <div class="card-body">
                            <mmf-table entity="systemParameters" inline-actions-disabled singleChoice>
                            </mmf-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { createHelpers } from 'vuex-map-fields';
import {gridFields, filterFields}  from "@/model/adm/SystemParameters";
import MmfTable from "@/components/MmfTable";
import MmfButton from "@/components/MmfButton";

// create a helper to generate getters and setters with namespace
const { mapFields } = createHelpers({
    getterType: 'systemParameters/getField',
    mutationType: 'systemParameters/updateField',
  });

export default {
  data () {
    return {
      currentPage: 1,
      displayedValue: "",
      perPage: 15
    }
  },
  components: { MmfTable, MmfButton },
  name: "systemParametersList",
  computed: {
        // generate and add getters and setters using the filter names defined in
        // entity model
        ...mapFields(filterFields),
        //define the state of rows and fields of grid
        ...mapState({
            rows: state => state.systemParameters.rows,
            checkedItems: state => state.systemParameters.checkedItems,
            showNoResultAlert: state => state.base.showNoResultAlert,
            tableColumns: gridFields
        })
  },
  methods: {
    toggleAll(checked) {
        if(!checked){
            this.$store.commit( "systemParameters/checkedItems", [] );
            return;
        }

        var auxVector = []
        for (let i in this.$store.state.systemParameters.rows)
            auxVector.push(this.$store.state.systemParameters.rows[i].id)

        this.$store.commit( "systemParameters/checkedItems", auxVector );
    },
    showValue(item){
        this.displayedValue = item.value;
    },
    ...mapActions("base", ["MMFselectRow", "MMFselectAllRows", "MMFNew", 
    "MMFEdit", "MMFLoadRows", "MMFDelete", "MMFClearFilter"])
  }
};
</script>
